import { render } from "./FavGuide.vue?vue&type=template&id=21c24ed7&scoped=true"
import script from "./FavGuide.vue?vue&type=script&lang=js"
export * from "./FavGuide.vue?vue&type=script&lang=js"

import "./FavGuide.vue?vue&type=style&index=0&id=21c24ed7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c24ed7"]])

export default __exports__